import React, { useEffect, useState,useRef } from "react";
import GoogleMapReact from "google-map-react";
import {
  GOOGLE_PACES_API_BASE_URL,
  GOOGLE_PLACES_API_KEY,
  RECOMMENDED_CANDIDATES,
  Recruiter_Profile_Status,
} from "../../../Service/service";
import { getData, postData } from "../../../Service/ApiMethod";
import MapBlackScreen from "./MapBlackScreen";
// import PopUp from "./ExtraPopup";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal } from 'react-bootstrap';

const MapView = (props) => {
  const [userProfileData, setUserProfileData] = useState()
  // const CurrentLocation = useLocation()

  const location = useLocation()
  // console.log(CurrentLocation , "CurrentLocation")

  let mapview = props?.userMap?.data == undefined ?location.state?.userMap?.data:props?.userMap?.data
  let singleUser = props?.userLocation
  let setUpdateChanges = props?.setUpdateChanges
  let updateChanges = props?.updateChanges
  // let isSubscribed = location.state?.isSub == undefined ? true:location.state?.isSub
  // let { t } = useTranslation();

  // const singleCandidateData =props?.singleCandidateData

  console.log(props?.userMap,'Mapview data', mapview)
  console.log('userLocation', singleUser)

  console.log('img', singleUser ? singleUser?.image : '')

  const height = props?.mapHeight
  const defaultProps = {
    center: {
      lat: 28.6326784,
      lng: 77.2046848,
      lat: parseFloat(localStorage?.getItem("lat")),
      lng: parseFloat(localStorage?.getItem("lng"))


    },
    zoom: 11,
  };
  // const handleApiLoaded = (map, maps) => {
  //   const obj = {
  //     map: map,
  //     maps: maps,
  //   };
  //   postData(obj, GOOGLE_PACES_API_BASE_URL)
  //     .then((res) => res.json())
  //     .then((res) => console.log(res));
  // };

  console.log(props?.userMap);

  const apiIsLoaded = (map, maps) => {
    if (singleUser) {
      const directionsService = new window.google.maps.DirectionsService();
      const directionsRenderer = new window.google.maps.DirectionsRenderer(
        { suppressMarkers: true }
      );


      directionsRenderer.setMap(map);
      const origin = { lat: parseFloat(localStorage?.getItem("lat")), lng: parseFloat(localStorage?.getItem("lng")) };
      const destination = { lat: parseFloat(singleUser?.latitude) || parseFloat(singleUser?.seeker_details[0]?.latitude), lng: parseFloat(singleUser?.longitude) || parseFloat(singleUser?.seeker_details[0]?.longitude) };
      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: window.google.maps.TravelMode.DRIVING
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            directionsRenderer.setDirections(result);
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
    }
  };

  useEffect(() => {
    profile_Status()
  }, [])

  const getList =()=>{
    getData(RECOMMENDED_CANDIDATES)
    .then(res => res.json())
    .then(data => {
      console.log('profile data', data?.data)
      setUserProfileData(data?.data)
    })
  }



  const [loaderStart, setLoaderstart] = useState(false)
  const [listView, setListview] = useState([])
  const List = useRef([])
  const latss = useRef("")
  const longs = useRef("")
  const isSub = useRef(false)
  const profile_Status = () => {
    getData(Recruiter_Profile_Status)
      .then((response) => response.json())
      .then((res) => {
        console.log(res,"cdddd");
        // setLoaderstart(false)

        isSub.current = res?.data?.is_subscribed
        let lat = res?.data?.latitude
        let long = res?.data?.longitude
        latss.current = res?.data?.latitude
        longs.current = res?.data?.longitude
        if (res?.data?.is_subscribed == false) {
          console.log("saaaaaaaaa");
          cateGroup(lat, long)

        } else {
          getList()
        }
      })
      .catch((err) => {
        // setLoaderstart(false)
        console.log("profileStatusErr");
      });
  };




  const cateGroup = async (currentLatitude, currentLongitude) => {
    setLoaderstart(true);
  
    var request = {
      radius: props?.rang,
      "latitude": currentLatitude,
      "longitude": currentLongitude
    };
    setTimeout(() => {
      fetch("https://api.catzapp.com/recruiter/seekers_list_by_category/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
        },
        body: JSON.stringify(request),
      })
        .then((response) => response.json())
        .then((res) => {
          setLoaderstart(false);
          console.log('res~~~~~~2222SEAR', res);
          setListview(res.data)
          List.current = res.data
        })
        .catch(error => {setLoaderstart(false) });
    }, 1000)
  }









  return (
    <div style={{ height: `${height ? height : '100vh'}`, width: "100%", position: 'relative' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: GOOGLE_PLACES_API_KEY }}
        defaultCenter={defaultProps?.center}
        defaultZoom={defaultProps?.zoom}
        yesIWantToUseGoogleMapApiInternals
        options={{ disableDefaultUI: true }}

        onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)}
      >
        <Users
          lat={localStorage?.getItem("lat")}
          lng={localStorage?.getItem("lng")}
          image={userProfileData?.image || ''}
        />

        {singleUser &&
          <SingleCandidate
            lat={singleUser?.latitude || (singleUser?.seeker_details[0]?.latitude)}
            lng={singleUser?.longitude || (singleUser?.seeker_details[0]?.longitude)}
            image={singleUser?.image !== undefined ? singleUser?.image : "../images/Vector.png" || (singleUser?.seeker_details[0]?.image)}
            name={singleUser?.first_name || (singleUser?.seeker_details[0]?.first_name)}
          />}


       
            {mapview?.map((item, i) => {
              return (
                <AnyReactComponentTwo
                key={i}
                lat={item?.latitude}
                lng={item?.longitude}
                image={item?.image == undefined ? item.category_icon:item?.image}
                name={item.first_name == undefined ? item.category_name:item?.first_name + " " + item?.last_name}
                item={item}
                setUpdateChanges={setUpdateChanges}
                updateChanges={updateChanges}
              />
              );
            })}
    

      </GoogleMapReact>
    </div>
  );
};

export default MapView;


const Users = (props) => {
  // const text = props?.text
  const image = props?.image
  const { t } = useTranslation();
  return (
    <>
      <div style={{ textAlign: 'center', width: '45px' }}>
        <img src={image || "../images/Vector.png"} className="text-danger" alt="you" style={{ width: '50px', height: '50px', borderRadius: '50%' }} />
        <div style={{ color: "white", backgroundColor: "orange", fontWeight: '600', borderRadius: "10%" }}>{t('You')}</div>
      </div>
    </>
  )
};

const SingleCandidate = (props) => {
  // const text = props?.text
  const candidateImg = props?.image
  // const { t } = useTranslation();
  const name = props?.name
  console.log('single candidate detailsssss', candidateImg, name)

  return (
    <>
      <div style={{ textAlign: 'center', width: '45px' }}>
        <img src={candidateImg || "./images/Vector.png"} className="text-danger" alt="you" style={{ width: '50px', height: '50px', borderRadius: '50%' }} />
        <h6 style={{ color: 'black', fontWeight: '800' }}>{name}</h6>
      </div>
    </>
  )
};

const AnyReactComponentTwo = (props) => {
  const [mapCandidateDetails, setMapCandidateDetails] = useState(false)
  const [popup, setPopUp] = useState(false)
  const { t } = useTranslation();
  const candidateDetails = props?.item
  // console.log('candidateDetails', candidateDetails)
  const setUpdateChanges = props?.setUpdateChanges
  const updateChanges = props?.updateChanges

  return (
    <>
      <div>
        <div style={{ textAlign: 'center', width: '65px',backgroundColor:'#fff' }} >
          <img
            alt="img"
            src={props?.image || "./images/Vector.png"}
            style={{ height: "50px", width: "50px", border: ' 2px solid white' }}
            onClick={(e) => {
              console.log()
              // e.stopPropagation()
              if(props?.item?.percentage_match != undefined){
                setPopUp(!popup)
                setMapCandidateDetails(false)
              }
             
            }}
          />
          <div className='d-flex percent mx-3' >
            <img src="../images/match-badge.png" style={{ height: '10px', width: '10px', color: 'white' }} />
            <p className="font-8" style={{}}>{props?.item?.percentage_match == undefined? props?.item?.category_name:parseInt(props?.item?.percentage_match)}</p>

          </div>

        </div>

        {
          popup &&
          <div className="mapp-outer"

            style={{
            
            }}>
            <div className="name-distance" style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontSize: "12px", fontWeight: "400" }}>{props?.name}&nbsp;</span>
              <h6 style={{ fontSize: '10px' }} >{parseInt(props?.item?.distance)}&nbsp;{t('KM Away')}</h6>
            </div>
            <p style={{ marginLeft: "2px", marginTop: "-4px", marginLeft: '2px', color: 'black', fontSize: '9px',fontWeight:'600',marginTop:'10px' }}>{props?.item?.profile_title}</p>
            <div style={{ display: "flex", alignContent: "center", }}>
              <div className='d-flex my-1' >
                <img src="../images/match-badge.png" style={{ height: '10px', width: '10px', color: 'white' }} />
                <p className="" style={{ fontSize: '8px' }}>{parseInt(props?.item?.percentage_match)}&nbsp;{t('Match')} </p>
                <span
                  style={{ color: 'blue', fontSize: '9px', marginLeft: '15px' }} onClick={() => {
                    console.log(props?.item,"dddds22222")
                    setMapCandidateDetails(true)

                  }}  >{t('View Profile')}  </span>
              </div>


            </div>
          </div>

        }
        {mapCandidateDetails &&
          <>
     
          <Modal className="modal-mapuser" show={mapCandidateDetails} onHide={() => setMapCandidateDetails(false)} style={{  }}>
            {/* <div className='blur-screen-full-area flex-center' style={{ position: 'inherit', top: '-100px', left:'0', zIndex: '999999999999999999999999', height: '100vh', background:'rgb(0, 0, 0, 0.7' }}> */}
            <MapBlackScreen candidateData={candidateDetails} setMapCandidateDetails={setMapCandidateDetails} setUpdateChanges={setUpdateChanges} updateChanges={updateChanges} />
            {/* </div> */}
            </Modal>
           
          </>
        }
      </div>
    </>
  )
}


// const AnyReactComponent = (props) => {
//   return(
//     <>
//      <div style={{ textAlign: 'center', width: '45px' }} >
//           <img
//             alt="img"
//             src={props?.image || "./images/Vector.png"}
//             style={{ height: "50px", width: "50px", border: ' 2px solid white' }}
//             onClick={(e) => {
//               // e.stopPropagation()
//               // setPopUp(!popup)
//               // setMapCandidateDetails(false)
//             }}
//           />
//           <div className='d-flex  justify-content-center percent mx-3' >
//             <img src="../images/match-badge.png" style={{ height: '10px', width: '10px', color: 'white' }} />
//             <p className="font-8" style={{}}>{props?.name}</p>

//           </div>

//         </div>
//     </>
//   )
// };